export default [
  {
    path: '/login',
    name: 'login',
    component: () => import('@/pages/login/Login.vue'),
    props: true,
  },
  {
    path: '/forgetpass',
    name: 'forgetPassword',
    component: () => import('@/pages/login/ForgetPassword.vue'),
    props: true,
  },
  {
    path: '/verifycode',
    name: 'verifyCode',
    component: () => import('@/pages/login/VerifyCode.vue'),
    props: true,
  },
  {
    path: '/resetpass/:verifyCode',
    name: 'resetPassword',
    component: () => import('@/pages/login/ResetPassword.vue'),
    props: true,
  },
];
